export const RegionsActionTypes = {
  CREATE_REGION: '[REGIONS] Create new Region',
  SET_REGIONS: '[REGIONS] Set Regions',
  DELETE_REGION: '[REGIONS] Delete Region',
  UPDATE_REGION: '[REGIONS] Update Region',
  ADD_POSTAL_CODE: '[REGIONS] Add Postal Code',
  REMOVE_POSTAL_CODE: '[REGIONS] Remove Postal Code'
};
